import { Button } from '@klear/ui/components/button'
import { FileText } from 'lucide-react'
import { AlertTriangle } from 'lucide-react'

interface AchAgreementContentProps {
  userEmail?: string | null
  accountCount: number
  externalCount: number
  klearCount: number
  onReviewAndSign: () => void
}

export function AchAgreementContent({
  userEmail,
  accountCount,
  externalCount,
  klearCount,
  onReviewAndSign
}: AchAgreementContentProps) {
  return (
    <>
      <div className="bg-yellow-50 border-b border-yellow-200 dark:bg-yellow-950 dark:border-yellow-900 rounded-t-lg px-4 py-3">
        <div className="flex items-start gap-2 pt-3">
          <AlertTriangle className="w-5 h-5 text-orange-600 dark:text-orange-400 shrink-0 mt-0.5" />
          <div className="flex-1">
            <div className="font-semibold text-sm text-foreground mb-1">Action Required</div>
            <div className="text-xs text-foreground">
              {accountCount === 1
                ? 'One bank account requires an ACH agreement signature.'
                : `${accountCount} bank accounts require ACH agreement signatures.`}{' '}
              Please review and sign once to cover all accounts.
            </div>
          </div>
        </div>
      </div>
      <div className="px-4 pt-6 pb-4">
        <h2 className="text-xl font-semibold text-foreground mb-2">ACH Agreement</h2>
        {userEmail && <div className="text-sm text-muted-foreground mb-4">Welcome back, {userEmail}</div>}
        <div className="flex items-center gap-3 p-4 bg-muted/50 rounded-lg border border-border mb-6">
          <div className="shrink-0 w-10 h-10 rounded-full bg-muted flex items-center justify-center">
            <FileText className="w-5 h-5 text-muted-foreground" />
          </div>
          <div className="flex-1">
            <div className="font-medium text-sm text-foreground">
              {accountCount} account{accountCount !== 1 ? 's' : ''} to be covered by this agreement
            </div>
            <div className="text-xs text-muted-foreground">
              {externalCount > 0 && `${externalCount} external`}
              {externalCount > 0 && klearCount > 0 && ', '}
              {klearCount > 0 && `${klearCount} Klear`}
            </div>
          </div>
          <Button size="sm" onClick={onReviewAndSign}>
            Review and sign
          </Button>
        </div>
      </div>
    </>
  )
}
